export default __webpack_public_path__ + "static/media/logo.f7c39cf3.png";